<template>
    <div class="page">
        <div class="header">
            <div>
                <img class="logo" src="/static/featnet/peipei.png"/>
            </div>
            <div>
                <div class="name">多陪</div>
                <div class="domain">专注陪聊陪玩系统开发</div>
            </div>
        </div>

        <div class='fullname'>
            <div class='name'>汕头市飞鸟网络科技有限公司</div>
            <div class="desc">IT服务 · 互联网软件服务商</div>
        </div>

        <div class='contact-items'>
            <div class='item' bindtap='callPhone'>
                <img class='icon' src="/static/featnet/icon_phone.png"/>
                <div class='body-phone'>
                    <div class='title-phone'>联系电话</div>
                    <div class='content-phone'>13643033371</div>
                </div>
                <div name="标签一" type="border" color="blue"><a href="tel:13643033371">拨打电话</a></div>
            </div>

            <!--<div class='item' bindtap='bindOpenMap'>-->
            <!--<img class='icon' src="/static/featnet/icon_location.png"  />-->
            <!--<div class='body'>-->
            <!--<div class='title'>地址</div>-->
            <!--<div class='content'>广东省汕头市龙湖区金鸿公路广东新美育大楼</div>-->
            <!--</div>-->
            <!--<div name="标签一" type="border" color="blue">导航</div>-->
            <!--</div>-->
            <div class='item' bindtap='bindOpenMap'>
                <div class='body text-center'>
                    <div class='content'>
                        <div>
                            <div class='title'>扫码立即咨询</div>
<!--                            <img v-if="qrCode" :src="qrCode" class="qr-img"/>-->
                            <img src="/static/featnet/mp_qrcode3.jpg" class="qr-img"/>
                        </div>
                        <!--            <div>-->
                        <!--              <div class='title'>客服小姐姐</div>-->
                        <!--              <img src="/static/featnet/mp_qrcode2.png"  class="qr-img" />-->
                        <!--            </div>-->
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>

import {addTechView} from "@/api/page_view";
import {getTechSupportContact} from "@/api/tech_support";

export default {
    name: 'index',
    data() {
        return {
            qrCode: null
        }
    },
    methods: {
        loadData() {
            getTechSupportContact().then((res)=> {
                const data = res.data
                if(data.code === 0){
                    this.qrCode = data.qrCode
                }
            })
        }
    },
    mounted() {
        this.loadData()
    },
    activated() {
        addTechView()
    }
}
</script>

<style lang="less" scoped>

.page {
  width: 100%;
  min-height: 100%;
  position: absolute;
  background: #fff;
  height: 100vh;
}

.header {
  padding: 30px 0;
  display: flex;
  flex-direction: row;

  justify-content: center;
}

.header .logo {
  width: 70px;
  height: 70px;
  margin-right: 15px;
  border-radius: 50%;
  box-shadow: 0px 0px 8px #CCC;
}

.header .name {
  display: block;
  color: #000;
  font-weight: 600;
  font-size: 26px;
  letter-spacing: 1px;
}

.header .domain {
  display: block;
  color: #666;
  font-size: 16px;
  margin-top: 5px;
  letter-spacing: 1px;
}

.fullname {
  text-align: center;
  margin-bottom: 20px;
}

.fullname .name {
  font-size: 16px;
}

.fullname .desc {
  font-size: 14px;
  color: #999;
  margin-top: 5px;
}


.contact-items {

}

.body-phone {
  flex: 1;
  padding: 0 15px;

  .title-phone {
    color: #999;
  }
}

.contact-items .item {
  margin: 15px 15px;
  padding: 12px 10px;
  background: #fff;
  border-radius: 5px;
  display: flex;
  box-shadow: 0px 0px 3px #CCC;
  align-items: center;
  text-align: left;
  line-height: 18px;
}

.contact-items .item .icon {
  width: 32px;
  height: 32px;
  padding-right: 10px;
  border-right: 1px solid #ddd;
}

.contact-items .item .body {
  flex: 1;
}

.contact-items .item .body .title {
  font-size: 14px;
  color: #999;
  margin: 0 auto;
}

.contact-items .item .body .content {
  font-size: 14px;
  display: flex;
  justify-content: center;
}

.contact-items .item .tag {
  padding: 2px 8px;
}

.qr-img {
  height: 20vh;
}
</style>
